import wrapWithProvider from './wrap-with-provider';
import _onClientEntry from './on-initial-client-render';
export const wrapRootElement = wrapWithProvider;
export const onClientEntry = _onClientEntry;


export const onServiceWorkerUpdateReady = () => {
  window.location.reload(true);
};